import { render } from "./QuestionSetPublishDraftFormComponent.vue?vue&type=template&id=65c7a027&scoped=true"
import script from "./QuestionSetPublishDraftFormComponent.vue?vue&type=script&lang=js"
export * from "./QuestionSetPublishDraftFormComponent.vue?vue&type=script&lang=js"

import "./QuestionSetPublishDraftFormComponent.vue?vue&type=style&index=0&id=65c7a027&scoped=true&lang=css"

import exportComponent from "/tmp/build_905a1b4c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c7a027"]])

export default __exports__